import React from "react";
import Footer from "../components/Footer";
import BannerContacto from "../components/BannerContacto";
import { ToastContainer } from "react-toastify";
import NavBarTop from "../NavBarTop";
import { Helmet } from "react-helmet";
import env from "../config";
import { Slide } from "react-slideshow-image";
let urlMedia = env.url;

export const Noticias = () => {
  return (
    <>
      <Helmet>
        <title>Noticias | Vehicentro</title>
        <meta name="description" content="Pqrs" />
      </Helmet>
      <NavBarTop />
      <div className="containerNoticias">
        <div className="inicioFrase">
          <p>¡Gracias por acompañarnos en nuestro Gran Lanzamiento!</p>
          <br />
          <p>
            ¡Esperamos verte pronto y seguir construyendo juntos está gran
            historia!
          </p>
        </div>
      </div>
      <div className="containerNoticias">
        <div className="block2 noResponsive">
          <video
            preload="none"
            width="1920"
            height="1076"
            controls
            autoPlay={true}
            playsInline={true}
            muted
            loop
            src={urlMedia + "evento/lanzamiento.mp4"}
            className="videoWidth"
          />
        </div>
        <div className="imagenesContenedorNoticias">
          <div className="fotosSlider">
            <Slide duration={2000}>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec1-1.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec1-4.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec1-5.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
            </Slide>
          </div>
          <div className="fotosSlider">
            <Slide duration={2000}>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec1-2.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec1-6.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec1-7.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
            </Slide>
          </div>
          <div className="fotosSlider">
            <Slide duration={2000}>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec1-3.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec1-8.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec1-9.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
            </Slide>
          </div>
        </div>
      </div>
      <div className="containerNoticias">
        <div className="block2 noResponsive">
          <video
            preload="none"
            width="1920"
            height="1076"
            controls
            autoPlay={true}
            playsInline={true}
            muted
            loop
            src={urlMedia + "evento/monica.mp4"}
            className="videoWidth"
          />
        </div>
        <div className="imagenesContenedorNoticias">
          <div className="fotosSlider">
            <Slide duration={2000}>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-1.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-4.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-5.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-10.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
            </Slide>
          </div>
          <div className="fotosSlider">
            <Slide duration={2000}>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-2.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-6.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-7.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-11.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
            </Slide>
          </div>
          <div className="fotosSlider">
            <Slide duration={2000}>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-3.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-8.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec2-9.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
            </Slide>
          </div>
        </div>
      </div>
      <div className="containerNoticias">
        {/* < div className="block2 noResponsive" >
          <video preload="none" width="1920" height="1076" controls autoPlay={true} playsInline={true} muted loop src={urlMedia + "evento/joseNo.mp4"} className="videoWidth" />
        </div > */}
        <div className="imagenesContenedorNoticias">
          <div className="fotosSlider">
            <Slide duration={2000}>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-1.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-4.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-5.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-10.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-13.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
            </Slide>
          </div>
          <div className="fotosSlider">
            <Slide duration={2000}>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-2.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-6.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-7.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-11.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
            </Slide>
          </div>
          <div className="fotosSlider">
            <Slide duration={2000}>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-3.png)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-8.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-9.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
              <div className="each-slide-effect">
                <div
                  style={{
                    backgroundImage: `url(https://www.vehicentro.com/co/images/evento/sec3-12.jpg)`,
                    height: `32vw`,
                  }}
                ></div>
              </div>
            </Slide>
          </div>
        </div>
      </div>
      <div className="containerNoticias">
        <div className="imagenesContenedorNoticias">
          <div className="fotosSlider">
            <video
              preload="none"
              width="1920"
              height="1076"
              controls
              autoPlay={true}
              playsInline={true}
              muted
              loop
              src={urlMedia + "evento/testimonio1.mp4"}
              className="videoWidth"
            />
          </div>
          <div className="fotosSlider">
            <video
              preload="none"
              width="1920"
              height="1076"
              controls
              autoPlay={true}
              playsInline={true}
              muted
              loop
              src={urlMedia + "evento/testimonio2.mp4"}
              className="videoWidth"
            />
          </div>
          <div className="fotosSlider">
            <video
              preload="none"
              width="1920"
              height="1076"
              controls
              autoPlay={true}
              playsInline={true}
              muted
              loop
              src={urlMedia + "evento/testimonio3.mp4"}
              className="videoWidth"
            />
          </div>
        </div>
      </div>
      <ToastContainer />
      <BannerContacto />
      <Footer />
    </>
  );
};
